import type { Survey, CustomSurvey, TrashItem, HomeDashboard, HomeQuestion } from '@/types/survey.types';

export const MOCK_FUNDAMENTALS: Survey[] = [
  { id: 'mock-1', name: 'Fundamentals Q2 2026',    questions: 8,  status: 'active',   audience: 'Global',     activeDays: [0, 1, 2, 3, 4], description: 'Medición trimestral de los cuatro Fundamentales culturales', responses: 487, period: 'Abr–Jun 2026', category: 'general' },
  { id: 'mock-2', name: 'Liderazgo Efectivo',       questions: 6,  status: 'active',   audience: 'Managers',   activeDays: [0, 1, 2, 3, 4], description: 'Retroalimentación sobre prácticas de liderazgo', responses: 213, period: 'Continuo',     category: 'general' },
  { id: 'mock-3', name: 'Colaboración de Equipo',   questions: 5,  status: 'paused',   audience: 'México',     activeDays: [1], description: 'Trabajo en equipo y comunicación efectiva', responses: 98,  period: 'May 2026',     category: 'general' },
  { id: 'mock-4', name: 'Comunicación Asertiva',    questions: 7,  status: 'active',   audience: 'LATAM',      activeDays: [0, 1, 2, 3, 4, 5, 6], description: 'Claridad y respeto en la comunicación diaria', responses: 341, period: 'Continuo',     category: 'general' },
  { id: 'mock-5', name: 'Innovación y Creatividad', questions: 4,  status: 'inactive', audience: 'Tecnología', activeDays: [2, 4], description: 'Ideas nuevas y mejora continua', responses: 0,   period: '—',            category: 'general' },
];

export const MOCK_PERSONALIZADAS: CustomSurvey[] = [
  { id: 'mock-10', name: 'Onboarding 30 días',        createdBy: 'Roberto Valdez', status: 'active',           audience: 'México — Tecnología', questions: 5, responses: 23 },
  { id: 'mock-11', name: 'Feedback de proyecto Alpha', createdBy: 'Mariana Leal',   status: 'active',           audience: 'Cross-funcional',     questions: 3, responses: 18 },
  { id: 'mock-12', name: 'Evaluación de liderazgo EU', createdBy: 'Hans Müller',    status: 'pending_approval', audience: 'Europa',              questions: 4, responses: 0  },
];

export const MOCK_TRASH: TrashItem[] = [
  { id: 'mock-101', name: 'Pulse Q3 2025 (archivada)', responses: 312, daysLeft: 22, deletedBy: 'Ana Martínez', deletedAt: '2026-05-09', from: 'fundamentals'   },
  { id: 'mock-102', name: 'Feedback Piloto LATAM',      responses: 47,  daysLeft: 6,  deletedBy: 'Admin',         deletedAt: '2026-05-25', from: 'personalizadas' },
];

// ─── Question banks ───────────────────────────────────────────────────────────
// individual + matrix: se responde una vez por el grupo (sin expansión por persona)
// individual + individual: se expande N veces (una por participante) con nombre visible
// colectivo: se responde una vez, sin asociación a persona

/** Individual + Modo Matriz — todos los tipos de pregunta */
const QS_IND_MATRIX: HomeQuestion[] = [
  {
    id: 'im-1', type: 'likert', enfoque: 'individual', presentMode: 'matrix', required: true,
    text: '¿Escuchó activamente sin interrumpir durante la reunión?',
    fundamentalId: 'communicator', fundamentalName: 'Comunicador', behaviorLabel: 'Escucha activa',
  },
  {
    id: 'im-2', type: 'likert', enfoque: 'individual', presentMode: 'matrix', required: true,
    text: '¿Compartió conocimiento útil con el equipo?',
    fundamentalId: 'learner', fundamentalName: 'Aprendiz', behaviorLabel: 'Transferencia de conocimiento',
  },
  {
    id: 'im-3', type: 'behaviors', enfoque: 'individual', presentMode: 'matrix', required: true,
    text: '¿Demostró apertura al feedback recibido?',
    fundamentalId: 'team-builder', fundamentalName: 'Constructor de Equipo', behaviorLabel: 'Apertura al feedback',
    options: ['Totalmente', 'Bastante', 'Poco', 'Nada'],
  },
  {
    id: 'im-4', type: 'multiple', enfoque: 'individual', presentMode: 'matrix', required: true,
    text: '¿Cómo calificarías su participación en la toma de decisiones?',
    options: ['Lideró la discusión', 'Participó activamente', 'Participó cuando se le preguntó', 'No participó'],
  },
  {
    id: 'im-5', type: 'open', enfoque: 'individual', presentMode: 'matrix', required: false,
    text: '¿Hay algún comportamiento destacable que quieras mencionar?',
  },
];

/** Individual + Modo Individual — todos los tipos (se expande por participante) */
const QS_IND_CARD: HomeQuestion[] = [
  {
    id: 'ic-1', type: 'likert', enfoque: 'individual', presentMode: 'individual', required: true,
    text: '¿Respetó los tiempos y turnos de participación?',
    fundamentalId: 'communicator', fundamentalName: 'Comunicador', behaviorLabel: 'Escucha activa al consumidor',
  },
  {
    id: 'ic-2', type: 'behaviors', enfoque: 'individual', presentMode: 'individual', required: true,
    text: '¿Cuál fue su nivel de preparación para esta reunión?',
    fundamentalId: 'player-owner', fundamentalName: 'Player Owner', behaviorLabel: 'Orientación a resultados',
    options: ['Muy bien preparado/a', 'Preparado/a', 'Poco preparado/a', 'Sin preparación'],
  },
  {
    id: 'ic-3', type: 'multiple', enfoque: 'individual', presentMode: 'individual', required: true,
    text: '¿En qué área destacó más esta persona durante la reunión?',
    options: ['Comunicación', 'Resolución de problemas', 'Colaboración', 'Liderazgo'],
  },
  {
    id: 'ic-4', type: 'likert', enfoque: 'individual', presentMode: 'individual', required: true,
    text: '¿Generó un ambiente de confianza y apertura?',
    fundamentalId: 'team-builder', fundamentalName: 'Constructor de Equipo', behaviorLabel: 'Seguridad psicológica',
  },
  {
    id: 'ic-5', type: 'open', enfoque: 'individual', presentMode: 'individual', required: false,
    text: '¿Qué sugerencia le darías para mejorar su participación en futuras reuniones?',
  },
];

/** Colectivo — todos los tipos de pregunta */
const QS_COL: HomeQuestion[] = [
  {
    id: 'co-1', type: 'likert', enfoque: 'colectivo', presentMode: 'matrix', required: true,
    text: '¿La reunión tuvo objetivos claros desde el inicio?',
  },
  {
    id: 'co-2', type: 'behaviors', enfoque: 'colectivo', presentMode: 'matrix', required: true,
    text: '¿Cómo describirías el nivel de colaboración del equipo?',
    options: ['Excelente', 'Buena', 'Regular', 'Deficiente'],
  },
  {
    id: 'co-3', type: 'multiple', enfoque: 'colectivo', presentMode: 'matrix', required: true,
    text: '¿Cuál fue el resultado principal de esta reunión?',
    options: ['Decisión tomada', 'Plan de acción definido', 'Solo seguimiento', 'Sin resultado claro'],
  },
  {
    id: 'co-4', type: 'open', enfoque: 'colectivo', presentMode: 'matrix', required: false,
    text: '¿Qué aspecto de esta reunión podría mejorar en la próxima?',
  },
  {
    id: 'co-5', type: 'nps', enfoque: 'colectivo', presentMode: 'matrix', required: false,
    text: '¿Qué tan valiosa fue esta reunión para el equipo? (0 = nada, 10 = muy valiosa)',
  },
];

/** Mixto — individual+matrix + colectivo en la misma encuesta */
const QS_MIX: HomeQuestion[] = [
  {
    id: 'mx-1', type: 'likert', enfoque: 'individual', presentMode: 'matrix', required: true,
    text: '¿Contribuyó activamente con ideas o soluciones al equipo?',
    fundamentalId: 'team-builder', fundamentalName: 'Constructor de Equipo', behaviorLabel: 'Aporte de ideas',
  },
  {
    id: 'mx-2', type: 'behaviors', enfoque: 'individual', presentMode: 'matrix', required: true,
    text: '¿Demostró orientación a resultados durante la sesión?',
    fundamentalId: 'player-owner', fundamentalName: 'Player Owner', behaviorLabel: 'Enfoque en resultados',
    options: ['Siempre enfocado/a', 'Generalmente', 'A veces', 'No se observó'],
  },
  {
    id: 'mx-3', type: 'likert', enfoque: 'colectivo', presentMode: 'matrix', required: true,
    text: '¿La reunión fue bien estructurada y fluida?',
  },
  {
    id: 'mx-4', type: 'multiple', enfoque: 'colectivo', presentMode: 'matrix', required: true,
    text: '¿Cuánto tiempo de la reunión fue productivo?',
    options: ['Más del 80%', '60–80%', '40–60%', 'Menos del 40%'],
  },
  {
    id: 'mx-5', type: 'open', enfoque: 'colectivo', presentMode: 'matrix', required: false,
    text: '¿Qué cambiarías para hacer más efectivas estas reuniones?',
  },
  {
    id: 'mx-6', type: 'nps', enfoque: 'colectivo', presentMode: 'matrix', required: false,
    text: '¿Recomendarías este formato de reunión a otros equipos? (0–10)',
  },
];

// ─── Dashboard mock ───────────────────────────────────────────────────────────

export const MOCK_DASHBOARD: HomeDashboard = {
  pendingCount: 6,
  completedThisWeek: 5,
  currentScore: 3.4,
  stats: {
    totalAnswered: 47,
    totalOmitted: 5,
    streak: 8,
    participationRate: 90,
  },
  instances: [
    {
      id: 'inst-001',
      meetingTitle: 'Sincronía semanal — Ind. Tarjeta',
      meetingDate: '2026-05-28T10:00:00',
      durationMinutes: 45,
      participants: ['Ana García', 'Luis Mora', 'Petra Ramírez'],
      expiresAt: '2026-05-30T10:00:00',
      priority: 2,
      questions: QS_IND_CARD,   // individual+individual → 3 participantes × 6 preguntas = 18 efectivas
    },
    {
      id: 'inst-002',
      meetingTitle: 'Revisión de sprint — Ind. Matriz',
      meetingDate: '2026-05-28T14:30:00',
      durationMinutes: 60,
      participants: ['Carlos Díaz', 'María López', 'Roberto Valdez'],
      expiresAt: '2026-05-30T14:30:00',
      priority: 2,
      questions: QS_IND_MATRIX, // individual+matrix → una pregunta por tipo, sin expansión
    },
    {
      id: 'inst-003',
      meetingTitle: 'Retrospectiva del trimestre — Colectivo',
      meetingDate: '2026-05-27T09:00:00',
      durationMinutes: 90,
      participants: ['Roberto Valdez', 'Sofía Hernández', 'Miguel Ángel Torres', 'Claudia Ramos'],
      expiresAt: '2026-05-31T09:00:00',
      priority: 1,
      questions: QS_COL,        // colectivo → todas las preguntas de la reunión
    },
    {
      id: 'inst-004',
      meetingTitle: 'Planning Beta — Mixto',
      meetingDate: '2026-05-27T16:00:00',
      durationMinutes: 75,
      participants: ['David Morales', 'Laura Jiménez'],
      expiresAt: '2026-05-31T16:00:00',
      priority: 1,
      questions: QS_MIX,        // individual+matrix + colectivo mezclados
    },
    {
      id: 'inst-005',
      meetingTitle: 'All-Hands mensual — Colectivo',
      meetingDate: '2026-05-26T11:00:00',
      durationMinutes: 120,
      participants: ['Ana García', 'Luis Mora', 'Petra Ramírez', 'Carlos Díaz', 'María López'],
      expiresAt: '2026-06-02T11:00:00',
      priority: 0,
      questions: QS_COL,
    },
    {
      id: 'inst-006',
      meetingTitle: 'Onboarding Roberto — Ind. Tarjeta',
      meetingDate: '2026-05-26T15:00:00',
      durationMinutes: 30,
      participants: ['Roberto Valdez', 'Mariana Leal'],
      expiresAt: '2026-06-01T15:00:00',
      priority: 1,
      questions: QS_IND_CARD,   // individual+individual → 2 participantes × 6 preguntas = 12 efectivas
    },
  ],
};

// Legacy export kept for backward compatibility
export const MOCK_SURVEY_QUESTIONS = MOCK_DASHBOARD.instances[0].questions;

export const LIKERT_OPTIONS = [
  { value: 4, labelKey: 'survey.likert.always' },
  { value: 3, labelKey: 'survey.likert.usually' },
  { value: 2, labelKey: 'survey.likert.sometimes' },
  { value: 1, labelKey: 'survey.likert.rarely' },
];
